const fadeInPreset = ({
  delay = 0,
  duration,
}: {
  delay?: number
  duration?: number
}) => ({
  delay,
  duration,
  easing: 'easeInQuad',
  opacity: [0, 1],
})

const fadeInUpPreset = ({
  delay = 0,
  duration,
}: {
  delay?: number
  duration?: number
}) => ({
  delay,
  duration,
  easing: 'easeOutQuart',
  opacity: [0, 1],
  translateY: [1000, 0],
})

const fadeOutUpPreset = ({
  delay = 0,
  duration,
}: {
  delay?: number
  duration?: number
}) => ({
  delay,
  duration,
  easing: 'easeOutQuart',
  opacity: [1, 0],
  translateY: [0, -500],
})

const fadeOutPreset = ({
  delay = 0,
  duration,
}: {
  delay?: number
  duration?: number
}) => ({
  delay,
  duration,
  easing: 'easeInQuad',
  opacity: [1, 0],
})

const slideInPreset = ({
  delay = 0,
  duration,
  offset = 100,
}: {
  delay?: number
  duration?: number
  offset?: number
}) => ({
  delay,
  duration,
  easing: 'cubicBezier(0.16, 1, 0.3, 1)',
  opacity: [0, 1],
  translateX: [offset, 0],
})

const slideDownPreset = ({
  delay = 0,
  duration = 800,
}: {
  delay?: number
  duration?: number
}) => ({
  delay,
  duration,
  easing: 'easeOutExpo',
  opacity: [0, 1],
  translateY: ['-100%', 0],
})

const fadeOutUpSlightPreset = ({
  delay = 0,
  duration,
}: {
  delay?: number
  duration?: number
}) => ({
  delay,
  duration,
  easing: 'easeInQuad',
  opacity: [1, 0],
  translateY: [0, -10],
})

const animationPresets = {
  fadeIn: fadeInPreset,
  fadeInUp: fadeInUpPreset,
  fadeOut: fadeOutPreset,
  fadeOutUp: fadeOutUpPreset,
  fadeOutUpSlight: fadeOutUpSlightPreset,
  slideDown: slideDownPreset,
  slideIn: slideInPreset,
}

export default animationPresets
